<script>
import BaseAction from './BaseAction.vue'
export default {
  extends: BaseAction,
  props: {
    icon: {
      type: String,
      default: 'mdi-pencil'
    },
    color: {
      type: String,
      default: 'primary'
    }
  }
}
</script>

<style></style>
